import { useEffect, useState } from "react";
import { Image } from "antd";
import GOVCO from "../../../assets/landing/Logo.png";
import Escudo from "../../../assets/landing/Escudo.png";
import EscudoAlcaldiaBlanco from "../../../assets/landing/logo3.png";
import "./header.style.scss";
import { useNavigate } from "react-router";
import Buscador_icon from "../../../assets/Buscador.svg";
import { HeaderMobile } from "./headerMobile";
import { NavLink } from "react-router-dom";


export const HeaderPp = () => {
  const navigate = useNavigate();
  const goLogin = (): void => {
    navigate("/login");
  };

  const [isLogged, setIsLogged] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("user");
    setIsLogged(!!user);
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className="navbar sticky2">
      <div className="navbar-container">
        <nav className={`navbar-links ${isOpen ? "active" : ""}`}>
          <NavLink
            to="/pp"
            className={({ isActive }) => isActive ? "selected" : ""}
          >
            Inicio
          </NavLink>
          <NavLink
            to="/ppestimulos"
            className={({ isActive }) => isActive ? "selected" : ""}
          >
            Estímulos PP
          </NavLink>
          <NavLink
            to="/ppformacion"
            className={({ isActive }) => isActive ? "selected" : ""}
          >
            Formación
          </NavLink>
          <NavLink
            to="/ppfortalecimiento"
            className={({ isActive }) => isActive ? "selected" : ""}
          >
            Fortalecimiento
          </NavLink>
          <NavLink
            to="/ppagenda"
            className={({ isActive }) => isActive ? "selected" : ""}
          >
            Agenda PP
          </NavLink>
          <NavLink
            to="/ppcic"
            className={({ isActive }) => isActive ? "selected" : ""}
          >
            CIC
          </NavLink>
          <NavLink
            to="/"
            className={({ isActive }) => isActive ? "selected" : ""}
          >
            Estímulos Cultura
          </NavLink>
        </nav>

        <div className="navbar-toggle" onClick={toggleMenu}>
          <div className={`bar ${isOpen ? "open" : ""}`} />
          <div className={`bar ${isOpen ? "open" : ""}`} />
          <div className={`bar ${isOpen ? "open" : ""}`} />
        </div>
      </div>
    </header>
  );
};
